(() => {
  if (window.__lplP90Dialog) return;
  const template = document.querySelector('[data-lpl-p90-template]');
  if (!template) return;
  window.__lplP90Dialog = true;

  const panel = template.content.firstElementChild.cloneNode(true);
  panel.id = 'lpl-p90-dialog';
  panel.hidden = true;
  const scrim = document.createElement('div');
  scrim.className = 'lpl-p90__scrim';
  scrim.hidden = true;
  scrim.setAttribute('aria-hidden', 'true');
  document.body.append(scrim, panel);

  const mobile = window.matchMedia('(max-width: 719px)');
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const triggerSelector = '[data-lpl-p90-trigger]';
  const focusableSelector = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
  let opener = null;
  let owner = null;
  let mode = '';
  let hoverTimer = 0;
  let positionFrame = 0;
  let locked = null;
  let inertElements = [];

  const visible = element => !element.disabled && !element.closest('[hidden], [inert]') && element.getClientRects().length > 0;
  const controls = () => [...panel.querySelectorAll(focusableSelector)].filter(visible);
  const currentTrigger = () => {
    if (opener?.isConnected) return opener;
    return owner?.querySelector(`${triggerSelector}[data-lpl-p90-mode="${mode}"]`) || null;
  };
  const cancelHover = () => { window.clearTimeout(hoverTimer); hoverTimer = 0; };

  function lockScroll() {
    if (locked) return;
    const properties = ['position', 'top', 'left', 'width', 'overflow'];
    locked = { x: window.scrollX, y: window.scrollY, styles: properties.map(name => [name, document.body.style.getPropertyValue(name), document.body.style.getPropertyPriority(name)]) };
    document.body.style.position = 'fixed';
    document.body.style.top = `${-locked.y}px`;
    document.body.style.left = `${-locked.x}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    inertElements = [...document.body.children].filter(element => element !== panel && element !== scrim && !element.inert);
    inertElements.forEach(element => { element.inert = true; });
  }

  function unlockScroll() {
    if (!locked) return;
    const previous = locked;
    locked = null;
    inertElements.forEach(element => { element.inert = false; });
    inertElements = [];
    previous.styles.forEach(([name, value, priority]) => {
      if (value) document.body.style.setProperty(name, value, priority);
      else document.body.style.removeProperty(name);
    });
    window.scrollTo({ left: previous.x, top: previous.y, behavior: 'instant' });
  }

  function positionPanel() {
    positionFrame = 0;
    if (panel.hidden) return;
    opener = currentTrigger();
    if (!opener || !opener.getClientRects().length) { close(false); return; }
    if (mobile.matches) {
      panel.style.removeProperty('left');
      panel.style.removeProperty('top');
      panel.style.removeProperty('max-height');
      panel.style.removeProperty('width');
      panel.querySelector('.lpl-p90__content').style.removeProperty('max-height');
      panel.removeAttribute('data-lpl-p90-placement');
      return;
    }
    const anchor = opener.closest('.lpl-p90__row')?.querySelector('[data-lpl-p90-slot]') || opener;
    const rect = anchor.getBoundingClientRect();
    const viewport = window.visualViewport;
    const gutter = 16;
    const gap = 14;
    const viewportLeft = viewport?.offsetLeft || 0;
    const viewportTop = viewport?.offsetTop || 0;
    const viewportWidth = viewport?.width || document.documentElement.clientWidth;
    const viewportHeight = viewport?.height || window.innerHeight;
    const minTop = viewportTop + gutter;
    const maxBottom = viewportTop + viewportHeight - gutter;
    const usableHeight = Math.max(1, maxBottom - minTop);
    const content = panel.querySelector('.lpl-p90__content');

    // Measure at the actual available width before deciding which side fits.
    // scrollHeight retains the full content height even after a short-window cap.
    panel.style.width = `${Math.min(392, Math.max(1, viewportWidth - gutter * 2))}px`;
    panel.style.maxHeight = `${usableHeight}px`;
    content.style.maxHeight = `${Math.max(1, usableHeight - 2)}px`;
    const width = panel.offsetWidth;
    const desiredHeight = Math.min(content.scrollHeight + 2, usableHeight);
    const spaceBelow = Math.max(0, maxBottom - Math.max(minTop, rect.bottom + gap));
    const spaceAbove = Math.max(0, Math.min(maxBottom, rect.top - gap) - minTop);
    let placement = spaceBelow >= desiredHeight ? 'below'
      : spaceAbove >= desiredHeight ? 'above'
        : spaceAbove > spaceBelow ? 'above' : 'below';
    let availableHeight = placement === 'above' ? spaceAbove : spaceBelow;

    // In very short windows (or after scrolling the link out of view), keep a
    // readable panel inside the viewport instead of an unusable sliver/caret.
    if (rect.bottom <= minTop || rect.top >= maxBottom || availableHeight < Math.min(180, usableHeight)) {
      placement = 'floating';
      availableHeight = usableHeight;
    }
    const height = Math.min(desiredHeight, availableHeight);
    panel.style.maxHeight = `${height}px`;
    content.style.maxHeight = `${Math.max(1, height - 2)}px`;
    const naturalTop = placement === 'above' ? rect.top - gap - height
      : placement === 'below' ? rect.bottom + gap
        : rect.top + rect.height / 2 - height / 2;
    const top = Math.max(minTop, Math.min(naturalTop, maxBottom - height));
    const left = Math.max(viewportLeft + gutter, Math.min(rect.left, viewportLeft + viewportWidth - width - gutter));
    panel.dataset.lplP90Placement = placement;
    panel.style.left = `${left}px`;
    panel.style.top = `${top}px`;
    panel.style.setProperty('--lpl-p90-caret-left', `${Math.max(18, Math.min(rect.left - left + 26, width - 30))}px`);
  }

  function schedulePosition() {
    if (!positionFrame) positionFrame = window.requestAnimationFrame(positionPanel);
  }

  function presentation() {
    const sheet = mobile.matches;
    panel.classList.toggle('lpl-p90__sheet', sheet);
    panel.classList.toggle('lpl-p90__pop', !sheet);
    panel.setAttribute('aria-modal', String(sheet));
    scrim.hidden = !sheet || panel.hidden;
    if (!panel.hidden && sheet) lockScroll();
    else unlockScroll();
    positionPanel();
  }

  function open(trigger) {
    cancelHover();
    if (!panel.hidden && currentTrigger() === trigger) return;
    if (!panel.hidden) close(false);
    opener = trigger;
    owner = trigger.closest('lpl-purchase-options');
    mode = trigger.dataset.lplP90Mode;
    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    panel.querySelector('.lpl-p90__content').scrollTop = 0;
    presentation();
    panel.focus({ preventScroll: true });
  }

  function close(returnFocus) {
    cancelHover();
    if (panel.hidden) return;
    const target = currentTrigger();
    target?.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    scrim.hidden = true;
    unlockScroll();
    if (returnFocus && target) target.focus({ preventScroll: true });
  }

  function exitPopover(backward) {
    const trigger = currentTrigger();
    const all = [...document.querySelectorAll(focusableSelector)].filter(element => visible(element) && !panel.contains(element));
    const index = all.indexOf(trigger);
    const target = backward ? trigger : all[index + 1];
    close(false);
    if (target) target.focus({ preventScroll: true });
    else trigger?.focus({ preventScroll: true });
  }

  document.addEventListener('click', event => {
    const trigger = event.target instanceof Element ? event.target.closest(triggerSelector) : null;
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      cancelHover();
      if (!panel.hidden && currentTrigger() === trigger) close(true);
      else open(trigger);
      return;
    }
    if (panel.hidden) return;
    if (event.target === scrim || event.target.closest('[data-lpl-p90-close]')) {
      event.preventDefault();
      close(true);
    } else if (!mobile.matches && !panel.contains(event.target)) close(false);
  }, true);

  document.addEventListener('pointerover', event => {
    if (mobile.matches || !canHover.matches || event.pointerType === 'touch') return;
    const trigger = event.target.closest?.(triggerSelector);
    if (!trigger || trigger.contains(event.relatedTarget)) return;
    cancelHover();
    hoverTimer = window.setTimeout(() => { if (trigger.isConnected) open(trigger); }, 140);
  });
  document.addEventListener('pointerout', event => {
    const trigger = event.target.closest?.(triggerSelector);
    if (trigger && !trigger.contains(event.relatedTarget)) cancelHover();
  });

  document.addEventListener('keydown', event => {
    const trigger = event.target.closest?.(triggerSelector);
    if (trigger && event.key === 'ArrowDown') {
      event.preventDefault();
      event.stopPropagation();
      open(trigger);
      panel.focus({ preventScroll: true });
      return;
    }
    if (panel.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      close(true);
      return;
    }
    if (event.key !== 'Tab') return;
    const items = controls();
    const focused = document.activeElement;
    const index = items.indexOf(focused);
    if (mobile.matches) {
      if (event.shiftKey && (index <= 0)) {
        event.preventDefault();
        (items[items.length - 1] || panel).focus();
      } else if (!event.shiftKey && (index === items.length - 1)) {
        event.preventDefault();
        (items[0] || panel).focus();
      }
    } else if (event.shiftKey && (focused === panel || index === 0)) {
      event.preventDefault();
      exitPopover(true);
    } else if (!event.shiftKey && index === items.length - 1) {
      event.preventDefault();
      exitPopover(false);
    }
  }, true);

  document.addEventListener('focusin', event => {
    if (panel.hidden || panel.contains(event.target)) return;
    if (mobile.matches) panel.focus({ preventScroll: true });
    else if (event.target !== currentTrigger()) close(false);
  });
  mobile.addEventListener('change', () => {
    if (!panel.hidden) { presentation(); panel.focus({ preventScroll: true }); }
  });
  window.addEventListener('resize', schedulePosition, { passive: true });
  window.addEventListener('scroll', schedulePosition, { passive: true });
  window.visualViewport?.addEventListener('resize', schedulePosition, { passive: true });
  window.visualViewport?.addEventListener('scroll', schedulePosition, { passive: true });
  document.fonts?.ready.then(schedulePosition);
  document.addEventListener('shopify:section:unload', () => close(false));
  document.addEventListener('lpl-p90:triggers-updated', () => {
    if (panel.hidden) return;
    opener = currentTrigger();
    if (!opener || !opener.getClientRects().length) close(false);
    else { opener.setAttribute('aria-expanded', 'true'); schedulePosition(); }
  });
})();
